import React from "react";
import './Switch.scss'

function LabelSwitch ( props ){
  function toogleChange(){
    if(!props.disable){
      props.onChange();
    }
  }
  return (
    <>
      <label className={(props.disable?'disable-switch':'toogle')+" tooltip-switch"} >
        <input className={(props.disable?'disable-toggle-checkbox':'toggle-checkbox')} type="checkbox"  defaultChecked={props.checked} onChange={toogleChange}/>
        <div className={"toggle-switch "+(props.disable?'disable-toggle-switch':'')}></div>
        {
          props.tooltip && !props.disable?(
            <span className="tooltiptext">{props.tooltip}</span>
          ):(
            <>
            </>
          )
        }
      </label>
    </>
  );
}
export default LabelSwitch;